const modelName = 'Activity Categories';
const modelNameSingular = 'Activity Category';
const endpoint = '/activity-categories';

const setup = {
  title: modelName,
  singular: modelNameSingular,
  model: modelName.replace(/\s+/g, '-').toLowerCase(),
  canDelete: true,
  canAddNew: false,
  canSearch: true,
  endpoint,
  accessor: 'id',
};

export default setup;
